import React from 'react';
import PropTypes from 'prop-types';
import withErrorBoundary from '@/utils/errorBoundary';
import { PROTECTION_CARD_TYPES } from './protectionCardTypes';
import ProtectionCardVariantTrialIsActive from './variants/ProtectionCardVariantTrialIsActive';
import ProtectionCardVariantAutomaticProtectionAvailable from './variants/ProtectionCardVariantAutomaticProtectionAvailable';

const FACTORY_CARD_TYPES = [
  PROTECTION_CARD_TYPES.TRIAL_IS_ACTIVE,
  PROTECTION_CARD_TYPES.AUTOMATIC_PROTECTION_AVAILABLE,
];

const ProtectionCardFactory = ({
  testId,
  type,
  isAAClient,
  hideButtons,
  hideActivateTrial,
  onActivateProtectionPro,
  onActivateTrial,
  isTurbo,
}) => {
  if (type === PROTECTION_CARD_TYPES.TRIAL_IS_ACTIVE) {
    return (
      <ProtectionCardVariantTrialIsActive
        testId={testId}
        hideButtons={hideButtons}
        isAAClient={isAAClient}
        onActivateProtectionPro={onActivateProtectionPro}
        onActivateTrial={onActivateTrial}
      />
    );
  }

  return (
    <ProtectionCardVariantAutomaticProtectionAvailable
      testId={testId}
      hideButtons={hideButtons}
      hideActivateTrial={isTurbo || hideActivateTrial}
      isAAClient={isAAClient}
      onActivateProtectionPro={onActivateProtectionPro}
      onActivateTrial={onActivateTrial}
    />
  );
};

ProtectionCardFactory.propTypes = {
  testId: PropTypes.string,
  type: PropTypes.oneOf(FACTORY_CARD_TYPES).isRequired,
  isAAClient: PropTypes.bool,
  hideButtons: PropTypes.bool,
  hideActivateTrial: PropTypes.bool,
  onActivateProtectionPro: PropTypes.func,
  onActivateTrial: PropTypes.func,
};

ProtectionCardFactory.defaultProps = {
  testId: 'protection-card',
  isAAClient: false,
  hideButtons: false,
  hideActivateTrial: false,
  onActivateProtectionPro: undefined,
  onActivateTrial: undefined,
};

export default withErrorBoundary(ProtectionCardFactory, 'ProtectionCardFactory');
